import AdministratorsCommunities from "./AdministratorsCommunities";

export default AdministratorsCommunities;
